import { UntitledIcon } from '@faceup/icons'
import { usMicrophone01 } from '@faceup/icons/usMicrophone01'
import { AudioPlayer } from '@faceup/ui'
import { Button } from '@faceup/ui-base'
import moment from 'moment-timezone'
import { useState } from 'react'
import { defineMessages, FormattedMessage } from '../../TypedIntl'
import type { RecordType } from './types'
import { VoiceRecordingModal } from './VoiceRecordingModal'

const messages = defineMessages({
  startVoiceRecording: 'FollowUp.voiceRecording.button.start',
})

type Props = {
  recording: RecordType | null
  onRecordingSave: (recording: RecordType) => void
  onRecordingRemove: () => void
}

export const VoiceRecording = ({ recording, onRecordingSave, onRecordingRemove }: Props) => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  if (recording) {
    const readableDuration = moment.utc(recording?.duration ?? 0).format(`m:ss`)
    return (
      <AudioPlayer
        duration={readableDuration}
        onPlay={() => Promise.resolve(URL.createObjectURL(recording.data))}
        onRemove={async () => {
          onRecordingRemove()
        }}
      />
    )
  }

  return (
    <>
      <Button
        onClick={() => setIsModalVisible(true)}
        icon={<UntitledIcon icon={usMicrophone01} fontSize={16} />}
        size='large'
        type='primary'
        block={false}
        ghost
      >
        <FormattedMessage {...messages.startVoiceRecording} />
      </Button>
      <VoiceRecordingModal
        isVisible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        onRecordingSave={onRecordingSave}
      />
    </>
  )
}
